import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }

import { BaseForm, BaseFormItem, BaseInput, BaseFormRef } from 'xrk-components';
import {
  reactive,
  ref,
  withDefaults,
  computed,
  watch
} from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'base-insert',
  props: {
    placeholder: {},
    label: {},
    maxlength: {},
    ruleValidator: {},
    type: {},
    disabled: { type: Boolean, default: false },
    rows: { default: 7 },
    defaultValue: {},
    labelPosition: { default: 'top' },
    inputTexts: {},
    inputTextReplace: { type: Boolean, default: false }
  },
  setup(__props: any, { expose: __expose }) {

const ruleFormRef = ref<BaseFormRef>();
const props = __props;

// 添加处理输入的方法
const handleInput = (value: string) => {
  // 使用正则表达式限制只能输入两位小数的数字
  const regex = /^\d+(\.\d{0,2})?$/;
  if (value && !regex.test(value)) {
    // 如果不符合规则，可以进行处理（如截取或替换）
    const validValue = value.match(/^\d+(\.\d{0,2})?/);
    if (validValue) {
      formData.data = validValue[0];
    } else {
      formData.data = value
        .replace(/[^\d.]/g, '')
        .replace(/^(\d+\.\d{2}).*$/, '$1');
    }
  }
};

let formData = reactive<{ data: any }>({
  data: props.defaultValue ? props.defaultValue : ''
});
watch(
  () => formData.data,
  val => {
    if (val == null) {
      formData.data = '';
    }
  }
);
const rulesFrom = computed(() => {
  return [
    {
      required: true,
      validator: props.ruleValidator as (
        rule: any,
        value: any,
        callback: (error?: string | Error) => void
      ) => void,
      trigger: 'change'
    }
  ];
});

__expose({
  getFormData: () => {
    return new Promise((reslve, reject) => {
      ruleFormRef.value.validate(valid => {
        if (valid) {
          reslve(formData);
        } else {
          reject('error submit!');
        }
      });
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseForm), {
      "label-position": _ctx.labelPosition,
      "label-width": "200px",
      model: _unref(formData),
      ref_key: "ruleFormRef",
      ref: ruleFormRef,
      disabled: _ctx.disabled
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(BaseFormItem), {
          rules: rulesFrom.value,
          label: _ctx.label,
          prop: "data"
        }, {
          default: _withCtx(() => [
            (_ctx.type === 'number')
              ? (_openBlock(), _createBlock(_unref(BaseInput), {
                  key: 0,
                  style: {"width":"310px"},
                  modelValue: _unref(formData).data,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).data) = $event)),
                  maxlength: _ctx.maxlength,
                  "show-word-limit": "",
                  type: "text",
                  placeholder: _ctx.placeholder,
                  onInput: handleInput
                }, null, 8, ["modelValue", "maxlength", "placeholder"]))
              : (_openBlock(), _createBlock(_unref(BaseInput), {
                  key: 1,
                  style: {"width":"310px"},
                  modelValue: _unref(formData).data,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).data) = $event)),
                  maxlength: _ctx.maxlength,
                  "show-word-limit": "",
                  type: _ctx.type,
                  rows: _ctx.rows,
                  placeholder: _ctx.placeholder,
                  inputTextReplace: _ctx.inputTextReplace,
                  inputTexts: _ctx.inputTexts
                }, null, 8, ["modelValue", "maxlength", "type", "rows", "placeholder", "inputTextReplace", "inputTexts"]))
          ]),
          _: 1
        }, 8, ["rules", "label"])
      ]),
      _: 1
    }, 8, ["label-position", "model", "disabled"])
  ]))
}
}

})